module.exports = __webpack_public_path__ + "img/test.9ca9cb9b.png";